(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  function kvMeasuredFeaturedProductsHeight(grid) {
    var gridStyle = window.getComputedStyle(grid);
    var margins = (parseFloat(gridStyle.marginTop) || 0) + (parseFloat(gridStyle.marginBottom) || 0);
    return Math.ceil(grid.offsetHeight + margins);
  }

  function kvFeaturedProductsLayoutReady(grid) {
    var items = grid.children;
    if (!items.length) return true;

    var display = window.getComputedStyle(grid).display;
    if (display === 'grid' || display === 'flex' || display === 'inline-flex') return true;
    if (items.length === 1) return grid.offsetHeight > 0;

    var gridWidth = grid.clientWidth;
    var itemWidth = items[0].clientWidth;
    if (!gridWidth || !itemWidth) return false;
    return itemWidth < gridWidth - 1;
  }

  function kvFeaturedProductsImagesReady(grid) {
    var imgs = grid.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) return false;
    }
    return true;
  }

  function kvFeaturedProductsCssReady() {
    var nodes = document.querySelectorAll('link[href*="section-featured-products"]');

    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].rel === 'stylesheet' && nodes[i].sheet) return true;
    }

    return false;
  }

  function kvWatchFeaturedProducts(section) {
    if (!section || section.getAttribute('data-kv-featured-products-watched') === 'true') return;
    section.setAttribute('data-kv-featured-products-watched', 'true');

    var content = section.querySelector('.featured-products__content');
    var grid = section.querySelector('.featured-products__grid');
    var revealed = false;

    function lockHeight() {
      if (!content || !grid) return;
      var height = kvMeasuredFeaturedProductsHeight(grid);
      if (!height) return;
      content.style.height = height + 'px';
      content.style.overflow = 'hidden';
    }

    function reveal() {
      if (revealed) return;
      revealed = true;

      lockHeight();
      section.classList.add('kv-featured-products--ready');
      section.setAttribute('aria-busy', 'false');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!content) return;
          content.style.height = '';
          content.style.overflow = '';
        });
      });
    }

    function whenStable(done) {
      if (!grid || !grid.children.length) {
        done();
        return;
      }

      var lastHeight = -1;
      var lastChange = 0;
      var frames = 0;
      var maxFrames = 180;
      var started = false;

      function tick() {
        frames += 1;
        var height = grid.offsetHeight;
        var now = performance.now();
        var styled = kvFeaturedProductsLayoutReady(grid) || kvFeaturedProductsCssReady();
        var settled = kvFeaturedProductsImagesReady(grid) && styled && height > 0;
        var rect = section.getBoundingClientRect();
        var inView = rect.top < window.innerHeight && rect.bottom > 0;

        if (height !== lastHeight) {
          lastHeight = height;
          lastChange = now;
        }

        if (settled && !inView) lockHeight();

        if ((settled && now - lastChange >= 200) || frames >= maxFrames) {
          done();
          return;
        }

        requestAnimationFrame(tick);
      }

      function start() {
        if (started) return;
        started = true;
        requestAnimationFrame(tick);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(start);
      }

      setTimeout(start, 1000);
    }

    var designMode = window.Shopify && window.Shopify.designMode;
    if (designMode || !('IntersectionObserver' in window)) {
      whenStable(reveal);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        whenStable(reveal);
      });
    }, { rootMargin: '600px 0px', threshold: 0 });

    observer.observe(section);
  }

  function kvInitFeaturedProducts(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-kv-featured-products]')) {
      kvWatchFeaturedProducts(scope);
    }

    if (!scope.querySelectorAll) return;

    scope.querySelectorAll('[data-kv-featured-products]').forEach(kvWatchFeaturedProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      kvInitFeaturedProducts();
    });
  } else {
    kvInitFeaturedProducts();
  }

  document.addEventListener('shopify:section:load', function (event) {
    kvInitFeaturedProducts(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
